import { get, post } from "../../utils/BaseService";

export async function createTenantDetails(
  dispatch: any,
  props: any
) {
  return await post(dispatch, "/tenantDetails/create", props);
}
export async function getTenantDetailByTenantId(
  dispatch: any,
  tenantId:number
) {
  return await get(dispatch, `/tenantDetails/getByTenantId/${tenantId}`, null);
}

export async function uploadLogo(
  dispatch: any,
  props: any
) {
  return await post(dispatch, `/tenantDetails/uploadLogo`, props);
}